
export class Selected<T>{
  data: T;
  selected: boolean;

  constructor(t: T, sel: boolean){
    this.data = t;
    this.selected = sel;
  }
}
